import './App.css';
import './i18n';
import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AppShell from './components/AppShell';
import MainPage from './pages/MainPage';

// 첫 화면(지도) 외의 페이지는 처음 열 때 받아 초기 로딩을 가볍게 합니다.
const SearchPage = lazy(() => import('./pages/SearchPage'));
const ProductPage = lazy(() => import('./pages/ProductPage'));
const CalculatePage = lazy(() => import('./pages/CalculatePage'));
const InsightPage = lazy(() => import('./pages/InsightPage'));
const NewsPage = lazy(() => import('./pages/NewsPage'));
const LegalPage = lazy(() => import('./pages/LegalPage'));
const SettingsPage = lazy(() => import('./pages/SettingsPage'));
const Page = ({ children }) => <Suspense fallback={<main className="page-layout"><div className="page-body page-loading" aria-busy="true"><span/><span/><span/></div></main>}>{children}</Suspense>;

function App() {
  return <BrowserRouter><Routes><Route element={<AppShell/>}>
    <Route index element={<MainPage/>}/>
    <Route path="search" element={<Page><SearchPage/></Page>}/>
    <Route path="product/:id" element={<Page><ProductPage/></Page>}/>
    <Route path="calculate" element={<Page><CalculatePage/></Page>}/>
    <Route path="news" element={<Page><NewsPage/></Page>}/>
    <Route path="insight" element={<Page><InsightPage/></Page>}/>
    <Route path="terms" element={<Page><LegalPage type="terms"/></Page>}/>
    <Route path="privacy" element={<Page><LegalPage type="privacy"/></Page>}/>
    <Route path="about" element={<Page><LegalPage type="about"/></Page>}/>
    <Route path="data-sources" element={<Page><LegalPage type="source"/></Page>}/>
    <Route path="settings" element={<Page><SettingsPage/></Page>}/>
  </Route></Routes></BrowserRouter>;
}
export default App;
